import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, company, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-sky-500" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Company users must complete onboarding (super admin exempt)
  if (user.role !== "super_admin" && company && !company.onboarding_complete) {
    if (window.location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  }

  return children;
}
